// extracted by mini-css-extract-plugin
module.exports = {"sortFilterContainer":"_c9ed588","section":"_c88b566","checked":"_eb9e6f9","icon":"_82f76fa","sortBy":"_0d0045e","arrow":"_44bfcdb","upwardsArrow":"_1a072d0"};